import api from './api'

export default {
  dashboard(monthOffset = 0) {
    return api.get('/partner-licensings/:partnerLicensingId', { params: { monthOffset } })
  },
}
